module.exports = __webpack_public_path__ + "media/images/icons/twotone/printer-16a14fe4fbc234042419a44cb987d91d.svg";